import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  }, 
  {
    path: '/',
    name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [
      {
        path: '/',
        redirect: '/home'
      }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
          title: '首页'
        }
      }, 
      {
        path: '/announcement',
        name: 'solution',
        component: resolve => require(['@/view/Announcement_list'], resolve),
        meta: {
          title: '通知公告'
        },
      },
      {
        path: '/announcement/1',
        name: 'announcement',
        component: resolve => require(['@/view/Announcement_1'], resolve)
      },
      {
        path: '/solution',
        name: 'solution',
        component: resolve => require(['@/view/Solution'], resolve),
        meta: {
          title: '解决方案'
        },
        children: [
          {
            path: '/solution',
            redirect: '/solution/oneRealData'
          },
          {
            path: '/solution/oneRealData',
            name: 'solution',
            component: resolve => require(['@/view/Solution_oneRealData'], resolve),
            meta: {
              title: '解决方案丨实时数据平台'
            }
          },
          {
            path: '/solution/productionMonitor',
            name: 'solution',
            component: resolve => require(['@/view/Solution_productionMonitor'], resolve),
            meta: {
              title: '解决方案丨油气生产监控系统'
            }
          },
          {
            path: '/solution/intelligentAlarm',
            name: 'solution',
            component: resolve => require(['@/view/Solution_intelligentAlarm'], resolve),
            meta: {
              title: '解决方案丨油气生产智能预警系统'
            }
          },
          {
            path: '/solution/iotDeviceDiagnosis',
            name: 'solution',
            component: resolve => require(['@/view/Solution_iotDeviceDiagnosis'], resolve),
            meta: {
              title: '解决方案丨物联网设备在线诊断系统'
            }
          },
          {
            path: '/solution/energyControl',
            name: 'solution',
            component: resolve => require(['@/view/Solution_energyControl'], resolve),
            meta: {
              title: '解决方案丨能源管控平台'
            }
          },
          {
            path: '/solution/productionReport',
            name: 'solution',
            component: resolve => require(['@/view/Solution_productionReport'], resolve),
            meta: {
              title: '解决方案丨生产报表管理系统'
            }
          }
        ]
      }, {
        path: '/software',
        name: 'software',
        component: resolve => require(['@/view/Software'], resolve),
        meta: {
          title: '核心产品'
        },
        children: [
          {
            path: '/software',
            redirect: '/software/DATimsien'
          },
          {
            path: '/software/DATimsien',
            name: 'software',
            component: resolve => require(['@/view/Software_DATimsien'], resolve),
            meta: {
              title: '核心产品丨天行实时数据云平台'
            }
          },
          {
            path: '/software/TimMonitor',
            name: 'software',
            component: resolve => require(['@/view/Software_TimMonitor'], resolve),
            meta: {
              title: '核心产品丨天行智能生产监控系统'
            }
          },
          {
            path: '/software/TimRiver',
            name: 'software',
            component: resolve => require(['@/view/Software_TimRiver'], resolve),
            meta: {
              title: '核心产品丨天河流式计算引擎'
            }
          },
          {
            path: '/software/DMS',
            name: 'software',
            component: resolve => require(['@/view/Software_DMS'], resolve),
            meta: {
              title: '核心产品丨数据管理系统'
            }
          }
        ]
      }, {
        path: '/cases',
        name: 'cases',
        component: resolve => require(['@/view/cases'], resolve),
        meta: {
          title: '客户案例'
        }
      },{
        path: '/cases_rt_data',
        name: 'cases_rt_data',
        component: resolve => require(['@/view/case_RealTimeData'], resolve),
        meta: {
          title: '客户案例|实时数据平台'
        },
        children: [
          {
            path: '/cases_rt_data',
            redirect: '/cases_rt_data/case_01'
          },
          {
            path: '/cases_rt_data/case_01',
            name: 'cases_rt_data',
            component: resolve => require(['@/view/case_RealTimeData_01'], resolve),
            meta: {
              title: '厂级实时数据云平台'
            }
          },
          {
            path: '/cases_rt_data/case_02',
            name: 'cases_rt_data',
            component: resolve => require(['@/view/case_RealTimeData_02'], resolve),
            meta: {
              title: '办公网实时数据平台'
            }
          },
          {
            path: '/cases_rt_data/case_03',
            name: 'cases_rt_data',
            component: resolve => require(['@/view/case_RealTimeData_03'], resolve),
            meta: {
              title: '稠油生产实时数据平台'
            }
          }
        ]
      },{
        path: '/cases_monitor',
        name: 'cases_monitor',
        component: resolve => require(['@/view/case_Monitor'], resolve),
        meta: {
          title: '客户案例|实时数据平台'
        },
        children: [
          {
            path: '/cases_monitor',
            redirect: '/cases_monitor/case_01'
          },
          {
            path: '/cases_monitor/case_01',
            name: 'cases_monitor',
            component: resolve => require(['@/view/case_Monitor_01'], resolve),
            meta: {
              title: '国产化SCADA云平台建设'
            }
          },
          {
            path: '/cases_monitor/case_02',
            name: 'cases_monitor',
            component: resolve => require(['@/view/case_Monitor_02'], resolve),
            meta: {
              title: '某厂分级云组态监控应用'
            }
          },
          {
            path: '/cases_monitor/case_03',
            name: 'cases_monitor',
            component: resolve => require(['@/view/case_Monitor_03'], resolve),
            meta: {
              title: 'SCADA云平台多系统融合应用'
            }
          }
        ]
      },{
        path: '/cases_alarm',
        name: 'cases_alarm',
        component: resolve => require(['@/view/case_Alarm'], resolve),
        meta: {
          title: '客户案例|生产智能预警系统'
        },
        children: [
          {
            path: '/cases_alarm',
            redirect: '/cases_alarm/case_01'
          },
          {
            path: '/cases_alarm/case_01',
            name: 'cases_alarm',
            component: resolve => require(['@/view/case_Alarm_01'], resolve),
            meta: {
              title: '稠油生产预警系统'
            }
          },
          {
            path: '/cases_alarm/case_02',
            name: 'cases_alarm',
            component: resolve => require(['@/view/case_Alarm_02'], resolve),
            meta: {
              title: '集输生产智能预警系统'
            }
          },
          {
            path: '/cases_alarm/case_03',
            name: 'cases_alarm',
            component: resolve => require(['@/view/case_Alarm_03'], resolve),
            meta: {
              title: '采油厂智能生产预警系统'
            }
          }
        ]
      },{
        path: '/cases_energy',
        name: 'cases_energy',
        component: resolve => require(['@/view/case_Energy'], resolve),
        meta: {
          title: '客户案例|能源管控平台'
        },
        children: [
          {
            path: '/cases_energy',
            redirect: '/cases_energy/case_01'
          },
          {
            path: '/cases_energy/case_01',
            name: 'cases_energy',
            component: resolve => require(['@/view/case_Energy_01'], resolve),
            meta: {
              title: '新能源示范区能源管控平台'
            }
          },
          {
            path: '/cases_energy/case_02',
            name: 'cases_energy',
            component: resolve => require(['@/view/case_Energy_02'], resolve),
            meta: {
              title: '油气作业区能耗管控平台'
            }
          }
        ]
      },{
        path: '/cases_iot',
        name: 'cases_iot',
        component: resolve => require(['@/view/case_IOT'], resolve),
        meta: {
          title: '客户案例|物联设备管理'
        },
        children: [
          {
            path: '/cases_iot',
            redirect: '/cases_iot/case_01'
          },
          {
            path: '/cases_iot/case_01',
            name: 'cases_iot',
            component: resolve => require(['@/view/case_IOT_01'], resolve),
            meta: {
              title: '物联网设备在线诊断系统'
            }
          },
          {
            path: '/cases_iot/case_02',
            name: 'cases_iot',
            component: resolve => require(['@/view/case_IOT_02'], resolve),
            meta: {
              title: '设备运维系统'
            }
          }
        ]
      },{
        path: '/cases_report',
        name: 'cases_report',
        component: resolve => require(['@/view/case_IOT'], resolve),
        meta: {
          title: '客户案例|报表管理系统'
        },
        children: [
          {
            path: '/cases_report',
            redirect: '/cases_report/case_01'
          },
          {
            path: '/cases_report/case_01',
            name: 'cases_report',
            component: resolve => require(['@/view/case_Report_01'], resolve),
            meta: {
              title: '采油厂生产数据管理系统'
            }
          },
          {
            path: '/cases_report/case_02',
            name: 'cases_report',
            component: resolve => require(['@/view/case_Report_02'], resolve),
            meta: {
              title: '采气厂自动化报表系统'
            }
          }
        ]
      },
      {
        path: '/company',
        name: 'company',
        component: resolve => require(['@/view/company'], resolve),
        meta: {
          title: '公司介绍'
        }
      }, 
      {
        path: '/servicedetail',
        name: 'servicedetail',
        component: resolve => require(['@/view/ServiceDetail'],resolve),
        meta: {
          title: '相关服务'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js